import { useTheme } from "@mui/material";
import { ResponsiveBar } from "@nivo/bar";
import { tokens } from "../../../../theme";
import "moment/locale/nl";//import dutch locale
import moment from "moment";

export const BenchmarkChart = ({ gridRows = [], gridMeta = [], gridCols=[] }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const firstUnit = gridCols[0]["meta"]["unit"]
  let tickValues = []
  let tickFormat = "DDD-MM"

  let count = 0
  let divider = 1

  if (gridMeta["hisRollupInterval"] != null) {
    if (gridMeta["hisRollupInterval"]["unit"] === "mo") {
        divider = 1
        tickFormat = "MMMM"
      } else if (gridMeta["hisRollupInterval"]["unit"] === "day") {
        divider = 1
        tickFormat = "DD-MM-YYYY"
      } else {
        divider = 12
        tickFormat = "DD-MM-YYYY hh:mm"
      }
  } else {
    if (gridRows.length > 7 && gridRows.length <= 14) {
        divider = 2
    } else if (gridRows.length > 14 && gridRows.length <= 28) {
        divider = 4
    } else if (gridRows.length > 28 && gridRows.length <= 60) {
        divider = 7
    } else if (gridRows.length > 60) {
        divider = 12
    }
  }

  gridRows.forEach(row => {
    if (count % divider === 0) tickValues.push(row.id)
    count++
  });

  return (
    <ResponsiveBar
      data={gridRows}
      theme={{
        // added
        axis: {
          domain: { line: { stroke: colors.grey[100] }, },
          legend: { text: { fill: colors.grey[100] } },
          ticks: {
            line: {
              stroke: colors.grey[100],
              strokeWidth: 1,
            },
            text: {
              fill: colors.grey[100],
            },
          },
        },
        legends: { text: { fill: colors.grey[100] } },
      }}
      keys={gridMeta["cols"]}
      margin={{ top: 65, right: 20, bottom: 80, left: 90 }}
      padding={0.2}
      tooltip={(point) => {
        const pointName = gridCols.find((row) => row["name"] === point.id)["meta"]["id"]["dis"]
        const unit = gridCols.find((row) => row["name"] === point.id)["meta"]["unit"]
        return (
            <div style={{backgroundColor: 'white', color: 'black', padding: '5px', borderRadius: '10px'}}>
              <div>{`${pointName}: ${point.formattedValue}${unit}`}</div>
            </div>
          );
      }}
      valueScale={{ type: "linear" }}
      indexScale={{ type: "band", round: true }}
      colors={point => gridCols.find((row) => row["name"] === point.id)["meta"]["color"]}
      borderColor={{
        from: "color",
        modifiers: [["darker", "1.6"]],
      }}
      axisTop={null}
      axisRight={null}
      valueFormat=" >-.3f"
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 40,
        tickValues: tickValues,
        format: (value) => moment(value).format(tickFormat)
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        format: (value) => `${value}${firstUnit}`
      }}
      enableLabel={false}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor={{
        from: "color",
        modifiers: [["darker", 1.6]],
      }}
      legends={[
        {
          dataFrom: "keys",
          data: gridMeta["cols"].map((id, index) => ({
            id,
            color: gridCols.find((row) => row["name"] === id)["meta"]["color"],
            label: gridCols.find((row, index) => row["name"] === id)["meta"]["id"]["dis"]
          })),          
          anchor: "top-right",
          direction: "column",
          justify: true,
          translateX: 0,
          translateY: -50,
          itemsSpacing: 15,
          itemDirection: "right-to-left",
          itemWidth: 335,
          itemHeight: 0,
          itemOpacity: 1,
          symbolSize: 13,
          symbolShape: "circle",
          effects: [
            {
              on: "hover",
              style: {
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
      role="application"
    />
  );
};